import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { setLocale } from "@xs2event/js-lib/util";
import { useDistributorStore } from "@/store/distributor.js";
import { useUserStore } from "@/store/user.js";
import { useEventStore } from "@/store/event.js";
import { useCartStore } from "@/store/cart.ts";
import { isB2C } from "@/brandconfig";
import { i18n } from "../../../i18n.ts";
import { LOCALES } from "./locales.js";

// Shared by the top bar's language menu and the mobile navigation.
export const useLanguageSwitch = () => {
  const cartStore = useCartStore();
  const eventStore = useEventStore();
  const userStore = useUserStore();
  const distributorStore = useDistributorStore();

  const { locale } = useI18n();

  const country = computed(() => LOCALES[locale.value]?.title);
  const code = computed(() => LOCALES[locale.value]?.flag);
  const langCode = computed(() => LOCALES[locale.value]?.title);

  const updateCartLocale = (option: string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let cartItems: any[] = [];
    userStore.updateLocale(option).then(() => {
      cartItems = JSON.parse(localStorage[userStore.client_id]).items;
      cartItems.forEach((item) => {
        eventStore
          .fetchPreferredLanguageEvent(item.event.event_id, option)
          .then((res: { event_name: string }) => {
            item.event.event_name = res.event_name;
          })
          .then(() => {
            delete localStorage[userStore.client_id];
            localStorage[userStore.client_id] = JSON.stringify(cartItems);
            cartStore.items = cartItems;
            cartStore.updateReservation();
            setLocale(option);
          });
      });
    });
  };

  const switchLocale = (option: string) => {
    if (isB2C) {
      setLocale((i18n.locale = option));
    } else {
      if (userStore.client_id) {
        if (!!cartStore.items.length > 0) {
          updateCartLocale(option);
          distributorStore.languageChanged++;
        } else {
          userStore.updateLocale(option);
          setLocale(option);
          distributorStore.languageChanged++;
        }
      } else {
        setLocale(option);
        distributorStore.languageChanged++;
      }
    }
  };

  return { locale, country, code, langCode, switchLocale };
};
